/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedTransactionResponse } from '../models/PaginatedTransactionResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class TransactionsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * List society transactions
     * Returns a paginated list of financial transactions for a society. Only the society owner or an admin can access. Supports filtering by type and date range.
     * @returns PaginatedTransactionResponse List of transactions.
     * @throws ApiError
     */
    public transactionsControllerFindAll({
        societyId,
        type,
        from,
        to,
        page = 1,
        limit = 20,
    }: {
        /**
         * Society unique identifier
         */
        societyId: string,
        /**
         * Filter by transaction type
         */
        type?: 'PAYMENT' | 'TRANSFER' | 'REFUND' | 'PAYOUT' | 'FEE',
        /**
         * Filter from date (ISO 8601)
         */
        from?: string,
        /**
         * Filter to date (ISO 8601)
         */
        to?: string,
        /**
         * Page number
         */
        page?: number,
        /**
         * Items per page (max 200)
         */
        limit?: number,
    }): CancelablePromise<PaginatedTransactionResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/societies/{societyId}/transactions',
            path: {
                'societyId': societyId,
            },
            query: {
                'type': type,
                'from': from,
                'to': to,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. SOCIETY_OWNER or ADMIN role required.`,
                404: `Society not found.`,
            },
        });
    }
    /**
     * Get transaction summary
     * Returns aggregated totals (income, refunds, transfers, payouts) for a society within an optional date range.
     * @returns any Transaction summary.
     * @throws ApiError
     */
    public transactionsControllerGetSummary({
        societyId,
        from,
        to,
    }: {
        /**
         * Society unique identifier
         */
        societyId: string,
        from: string,
        to: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/societies/{societyId}/transactions/summary',
            path: {
                'societyId': societyId,
            },
            query: {
                'from': from,
                'to': to,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. SOCIETY_OWNER or ADMIN role required.`,
                404: `Society not found.`,
            },
        });
    }
}
